// extracted by mini-css-extract-plugin
export var inner = "footer-menu-group-module--inner--7f95f";
export var menu = "footer-menu-group-module--menu--ae4a1";
export var root = "footer-menu-group-module--root--b0659";
export var title = "footer-menu-group-module--title--a2b63";